export default "__VITE_PUBLIC_ASSET__649996d8__"